:host {
  display: block;
}

.breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
